import React from "react"
import styled from "styled-components"
import { theme, BGWrapper, section, flex } from "@/common/Mixin"
import NextImg from "@/common/components/NextImg/index"
import Heading from "@/common/components/_UI/Heading"
import Button from "@/common/components/_UI/Button"
// images=======================
import BGstar from "@/common/assets/image/walletAsAService/hero/BGstar.webp"
import diamond from "@/common/assets/image/walletAsAService/hero/diamond.svg"
import popLeft from "@/common/assets/image/walletAsAService/hero/popLeft.svg"
import popRight from "@/common/assets/image/walletAsAService/hero/popRight.svg"
import shiny from "@/common/assets/image/walletAsAService/hero/shiny.svg"
import BannerAnimation from "@/common/components/BannerAnimation"
import localFont from "next/font/local"
import icon from "@/common/assets/image/Icon/MenuIcon/WalletAsAService.svg"
const AsusRog = localFont({ src: "../../../../../public/fonts/AsusRog.ttf" })

export default function Hero({ t }) {
  return (
    <SectionWrapper>
      <BGWrapper id="BGStars">
        <BGstarWrapper className="no4">
          <NextImg src={BGstar} />
        </BGstarWrapper>
      </BGWrapper>
      <BGWrapper id="shiny">
        <ShinyWrapper>
          <Shiny>
            <NextImg src={shiny} />
          </Shiny>
        </ShinyWrapper>
      </BGWrapper>
      <BannerAnimation id="lines" />
      <BGWrapper id="circles">
        <Circle className="no1" />
        <Circle className="no2" />
        <Circle className="no3" />
        <Circle className="no4" />
        <Circle className="no5" />
      </BGWrapper>
      <BGWrapper id="Pops">
        <Pop className="no1">
          <NextImg src={popLeft} />
        </Pop>
        <Pop className="no2">
          <NextImg src={popRight} />
        </Pop>
      </BGWrapper>

      <Wrapper>
        <MainWrapper>
          <ProductTitleWrapper>
            <IconWrapper>
              <IconBox>
                <NextImg src={icon} />
              </IconBox>
            </IconWrapper>
            <Heading center as="h3" content="Wallet as a Service" />
          </ProductTitleWrapper>
          <TitleWrapper>
            <Heading
              center
              as="h1"
              primary
              content="GO "
              content2="CRYPTO"
              className={AsusRog.className}
            />
          </TitleWrapper>

          <Heading center as="h2" content={t("hero.title1")} />

          <DescWrapper>
            <Heading center as="p" content={t("hero.desc")} />
          </DescWrapper>

          <DiamondWrapper>
            <NextImg src={diamond} />
          </DiamondWrapper>
        </MainWrapper>
      </Wrapper>
      <ButtonWrapper>
        <Button
          content={t("button.start")}
          href="#Start"
          target
          id="Waas-Hero-start"
        />
      </ButtonWrapper>
      <BottomWrapper></BottomWrapper>
    </SectionWrapper>
  )
}
const SectionWrapper = styled.div`
  position: relative;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100%;
  height: clamp(600px, 100vh, 2000px);
  ${flex({ a: "start" })}
  @media (${theme.lg}) {
    height: clamp(600px, 100vh, 2000px);
  }
`
const Wrapper = styled.div`
  ${section}
  ${flex}
  margin: 0;
  width: 100%;
  position: relative;
  flex-direction: column;
  gap: var(--textGap);
  height: clamp(600px, 95vh, 2000px);
  @media (${theme.lg}) {
    height: clamp(600px, 90vh, 2000px);
  }
`
const MainWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 24px 0 0;
  gap: var(--textGap);
  @media (${theme.md}) {
    margin: 0px 0 0;
  }
`
const ProductTitleWrapper = styled.div`
  display: flex;
  gap: 12px;
  /* margin-bottom: 8px; */
  align-items: center;
  @media (${theme.lg}) {
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`
const TitleWrapper = styled.div`
  width: 100%;
  position: relative;

  h1 {
    z-index: 30;
    width: 100%;
    font-size: 100px;
    line-height: 0.9;
    font-weight: 900;
    letter-spacing: 0px;
    font-family: "__AsusRog_21e054", "__AsusRog_Fallback_21e054";
    &:nth-child(2) {
      text-shadow:
        0px 0 100px #000000,
        0px 0 150px #000000 !important;
      z-index: -1;
      position: absolute;
      top: 0;
    }
    @media (${theme.lg}) {
      font-size: 80px;
    }
    @media (${theme.md}) {
      font-size: 100px;
      margin: 16px 0;
      span {
        span {
          font-size: 42px;
        }
      }
    }
  }

  h2 {
    margin: 0;
  }
`
const DescWrapper = styled.div`
  width: clamp(300px, 90%, 800px);
  /* margin-top: 30px; */
  p {
    text-shadow: 0px 0px 20px #000000;
    color: #fff;
  }
  @media (${theme.lg}) {
    display: none;
  }
`

const LogoWrapper = styled.div`
  width: clamp(80px, 100%, 150px);
`
const DiamondWrapper = styled.div`
  position: absolute;
  width: clamp(400px, 30%, 800px);
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
  filter: drop-shadow(0px 0 100px ${theme.color.primary}66);
  @media (${theme.md}) {
    width: clamp(300px, 80%, 400px);
    filter: drop-shadow(0px 0 20px ${theme.color.primary}66);
  }
`
const BGstarWrapper = styled.div`
  width: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: -1;
  top: 50%;

  @media (${theme.md}) {
    width: 100%;
  }

  &.no1 {
    left: 50%;
    z-index: 3;
  }
  &.no2 {
    left: 25%;
    opacity: 1;
    transform: translate(-50%, -50%) rotate(180deg);
  }
  &.no3 {
    left: 75%;
    opacity: 0.5;
  }
  &.no4 {
    width: 120%;
    z-index: -2;
    left: 50%;
    opacity: 0.5;
    transform: translate(-50%, -50%) rotate(180deg);
    img {
      animation: zoom 2s ease-in-out forwards;
      opacity: 0;
      transform: scale(2);
    }
    @media (${theme.md}) {
      width: 200%;
    }
  }
`
const Circle = styled.div`
  --circle: 20%;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: #fff;
  width: var(--circle);
  padding-bottom: var(--circle);
  border-radius: 50%;
  filter: blur(150px);
  @media (${theme.lg}) {
    filter: blur(120px);
    --circle: 25%;
  }
  @media (${theme.md}) {
    filter: blur(120px);
    --circle: 30%;
  }
  @media (${theme.sm}) {
    filter: blur(100px);
    --circle: 35%;
  }
  @media (${theme.ssm}) {
    filter: blur(80px);
    --circle: 40%;
  }
  &.no1 {
    top: 20%;
    left: 10%;
    background: linear-gradient(#ff7a00, #ffc211);

    opacity: 0.5;
  }
  &.no2 {
    top: 80%;
    left: 90%;
    background: linear-gradient(#eb00ff, #0500ff);

    opacity: 0.5;
  }
  &.no3 {
    top: 80%;
    left: 30%;
    opacity: 0.3;
    background: linear-gradient(#ff002e, #ff002e);
  }
  &.no4 {
    top: 45%;
    left: 45%;
    opacity: 0.5;
    background: linear-gradient(#ffdb7e, #ffdb7e);
  }
  &.no5 {
    top: 30%;
    left: 60%;
    opacity: 0.8;
    background: linear-gradient(#0038ff, #0038ff);
  }
`
const Pop = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  span {
    animation: updown 24s infinite;
  }
  &.no1 {
    width: 20%;
    top: 90%;
    left: 5%;
    @media (${theme.md}) {
      width: 50%;
    }
    span {
      animation-delay: -3s;
    }
  }
  &.no2 {
    width: 30%;
    top: 5%;
    left: 95%;
    @media (${theme.md}) {
      width: 40%;
    }
  }
`
const Coin = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  width: 8%;
  span {
    animation: updown 6s infinite;
  }
  @media (${theme.md}) {
    width: 10%;
  }
  &.no1 {
    top: 30%;
    left: 15%;
    @media (${theme.md}) {
      width: 15%;
    }
    span {
      animation-delay: -3s;
    }
  }
  &.no2 {
    top: 20%;
    left: 75%;
    @media (${theme.md}) {
      top: 40%;
      left: 85%;
    }
    span {
      animation-delay: -5s;
    }
  }
  &.no3 {
    top: 80%;
    left: 85%;
    @media (${theme.md}) {
      width: 15%;
    }
    span {
      animation-delay: 0s;
    }
  }
`
const Star = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  span {
    animation: updown 10s infinite;
  }
  &.no1 {
    width: 80px;
    top: 12%;
    left: 30%;
    span {
      animation-delay: -3s;
    }
  }
  &.no2 {
    width: 30px;
    top: 70%;
    left: 25%;
    span {
      animation-delay: -5s;
    }
  }
  &.no3 {
    width: 60px;
    top: 70%;
    left: 75%;
  }
`
const ShinyWrapper = styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 80%;
  @media (${theme.md}) {
    width: 200%;
  }
`
const Shiny = styled.div`
  animation: spin 30s infinite linear;
`

const IconWrapper = styled.div`
  width: 48px;
  @media (${theme.lg}) {
    width: 32px;
  }
`
const IconBox = styled.div`
  position: relative;
  width: 100%;
`
const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 30px;
  z-index: 2;
  @media (${theme.lg}) {
    bottom: 48px;
  }
`
const BottomWrapper = styled.div`
  position: absolute;
  width: 100%;
  background: linear-gradient(
    0deg,
    ${theme.color.background} 0%,
    rgba(0, 0, 0, 0) 100%
  );
  height: 20%;
  bottom: 0;
`
